import { AccountSearchRequest, GetAccountRequest } from '@trukt/tms-api/AccountService';
import { createKey } from '../createKey';
import { AccountContactServiceKeys } from './serviceKeys';

const keyHandler = createKey('account');

export const AccountServiceKeys = {
  key: keyHandler.key,
  contact: AccountContactServiceKeys,
  search: keyHandler.createMethod<AccountSearchRequest>(),
  getById: keyHandler.createMethod<GetAccountRequest>(),
};
